// M6 — Manager tour: Schedule. 4 steps on /schedule.
export default {
  key: 'M6',
  route: '/schedule',
  steps: [
    {
      id: 'workcenter-rows',
      target: '[data-tour-id="schedule.gantt"]',
      title: 'Workcenter rows',
      desc: 'Each row in the Gantt is a workcenter. Manage workers and assignments under the Workcenters menu.',
    },
    {
      id: 'gantt-view',
      target: '[data-tour-id="schedule.gantt"]',
      title: 'Gantt timeline',
      desc: 'Tasks appear as bars across the timeline. Bar colors reflect status — the same color scheme as Order Control.',
    },
    {
      id: 'adjust',
      target: '[data-tour-id="schedule.gantt"]',
      title: 'Manual adjustments',
      desc: 'Drag bars to reschedule. Click a day header to toggle it between working and non-working.',
    },
    {
      id: 'auto-reorganize',
      target: '[data-tour-id="schedule.gantt"]',
      title: 'Automatic reorganization',
      desc: 'Any change you make automatically reorganizes downstream tasks and recalculates dates.',
    },
  ],
}
